import { useCallback, useEffect, useState } from "react";
import classnames from "classnames";
import { Pagination } from "antd";
import { commonApi, productApi } from "@/apis";
import defaultPng from "@/images/product/default.png";
import consultPng from "@/images/product/comment.png";
import emptyPng from "@/images/empty.png";
import "./index.less";
import { useNavigate } from "react-router";

const pageSize = 12;

const List = () => {
  const [dictCodes, setDictCodes] = useState<DictionaryItem[]>([
    { dictCode: "", dictValue: "全部产品" },
  ]);
  const [type, setType] = useState("");
  const [curPage, setCurPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [productList, setProductList] = useState<ProductInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 获取产品分类
  useEffect(() => {
    commonApi
      .getDictionaryList({
        dictTypeCodeList: ["mdm_product_label"],
      })
      .then((res) => {
        setDictCodes([
          { dictCode: "", dictValue: "全部产品" },
          ...res?.mdm_product_label,
        ]);
      });
  }, []);

  useEffect(() => {
    productApi
      .getProductList({
        enableStatus: "009",
        isShelf: "Y",
        productLevelCode: type,
        page: curPage,
        size: pageSize,
      })
      .then((res) => {
        const { total, records } = res;
        setTotal(total);
        setProductList(records);
      }).finally(() => {
        setLoading(false);
      });
  }, [type, curPage]);

  useEffect(() => {
    if (productList && productList.length) {
      if ((window as any).zc) {
        (window as any).zc("dynamic_ready");
      }
    }
  }, [productList]);

  const handleChangeTab = (dictCode: string) => {
    setType(dictCode);
  };

  const handleChangePage = (page: number) => {
    setCurPage(page);
  };

  const toDetailPage = useCallback((id: string) => {
    navigate(`/good/detail/${id}`)
  }, [navigate]);

  return (
    <div className="max-width">
      <div className="goods-wrapper">
        <ul className="goods-type">
          {dictCodes.map(({ dictCode, dictValue = "" }) => (
            <li
              className={classnames({ active: type === dictCode })}
              onClick={() => handleChangeTab(dictCode)}
              key={dictValue}
            >
              {dictValue}
            </li>
          ))}
        </ul>
        <div className="goods-list-wrapper">
          <ul className="goods-list">
            {productList && productList.length > 0 ? (
              productList.map(
                ({ id, productName, spec, pictureMediaList }) => (
                  <li key={id}>
                    <h4 onClick={() => toDetailPage(id)}>{productName}</h4>
                    <div className="info">
                      <div className="info-detail" onClick={() => toDetailPage(id)}>
                        <img
                          src={
                            pictureMediaList
                              ? `/crm-venus/v1/venus/images/${pictureMediaList[0]?.fileCode}.id`
                              : defaultPng
                          }
                          alt=""
                        />
                        <p>规格：{spec}</p>
                      </div>
                      <div className="consult zcbtn flex-c-c">
                        <img src={consultPng} alt="" />
                        <span>咨询</span>
                      </div>
                    </div>
                  </li>
                )
              )
            ) : (
              !loading && <img className="empty" src={emptyPng} alt="" />
            )}
          </ul>
          <Pagination
            className="goods-pagination"
            current={curPage}
            onChange={handleChangePage}
            defaultPageSize={pageSize}
            total={total}
          />
        </div>
      </div>
    </div>
  );
};

export default List;
